import cn from 'classnames';
import { HTMLAttributes } from 'react';
import { Text } from '@/shared/ui/core';
import { FieldRequiredMark } from '@/shared/ui/core';
import styles from './field.module.scss';


export function FieldLabel ({ className, required, ...props }: HTMLAttributes<HTMLDivElement> & {
    required?: boolean
}) {
    return (
        <Text
            size='md'
            weight='medium'
            className={ cn(styles.label, className) }
            { ...props }
        >
            { props.children }
            {
                required
                    ? <FieldRequiredMark/>
                    : null
            }
        </Text>
    );
}
